export default __webpack_public_path__ + "static/media/Benazzi_Family_IMG_018.5bbc4d50.jpg";